import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { useTheme, Box } from '@mui/material';


const DroppableCell = ({ employeeId, width, rowHeight }) => {
    const theme = useTheme();

    const { isOver, setNodeRef } = useDroppable({
        id: `row-${employeeId}`,
        data: {
            employeeId,
            dropType: 'EMPLOYEE_CELL',
        },
    });

    return (
        <Box
            ref={setNodeRef}
            sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width,
                height: rowHeight,
                backgroundColor: isOver ? theme.palette.action.hover : 'transparent',
                transition: 'background-color 0.15s',
                zIndex: 0,
            }}
        />
    );
};

export default React.memo(DroppableCell);
